import { render, staticRenderFns } from "./FitnessplanDetailsActivity.vue?vue&type=template&id=a681c102&"
import script from "./FitnessplanDetailsActivity.vue?vue&type=script&lang=js&"
export * from "./FitnessplanDetailsActivity.vue?vue&type=script&lang=js&"
import style0 from "./FitnessplanDetailsActivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports